import { getRouteApi } from "@tanstack/react-router"
import { useStore } from "zustand"
import { createStore } from "zustand/vanilla"

type TalentOverviewUiState = {
  // Member search input (HIGH CHURN — every keystroke)
  memberSearchInput: string

  // Copy/download feedback
  copyMessage: string | null

  setMemberSearchInput: (value: string) => void
  setCopyMessage: (message: string | null) => void
  dispose: () => void
}

export const createTalentOverviewUiStore = () =>
  createStore<TalentOverviewUiState>((set) => ({
    memberSearchInput: "",
    copyMessage: null,

    setMemberSearchInput: (value) => set({ memberSearchInput: value }),
    setCopyMessage: (message) => set({ copyMessage: message }),
    dispose: () => {
      set({
        memberSearchInput: "",
        copyMessage: null,
      })
    },
  }))

export type TalentOverviewUiStore = ReturnType<
  typeof createTalentOverviewUiStore
>

// Selector hooks
export const useMemberSearchInput = (store: TalentOverviewUiStore) =>
  useStore(store, (s) => s.memberSearchInput)

export const useCopyMessage = (store: TalentOverviewUiStore) =>
  useStore(store, (s) => s.copyMessage)

// Route-scoped access
const talentOverviewRouteApi = getRouteApi("/_authed/_admin/talent-overview")

export const useTalentOverviewRouteStore = () =>
  talentOverviewRouteApi.useRouteContext({
    select: (ctx) => ctx.talentOverviewStore,
  })
